module.exports = __webpack_public_path__ + "static/media/Prompt-Regular.16b4ce72.ttf";